import React, { HTMLProps } from "react";
import FullScreenContainer, {
  FullScreenContainerInputProps,
} from "./FullScreenContainer";
import classNames from "classnames";

type HalfScreenContainerProps = FullScreenContainerInputProps;

type HalfScreenContainerContentProps = HTMLProps<HTMLDivElement>;

const HalfScreenContainer: React.FC<HalfScreenContainerProps> & {
  ContentLeft: React.FC<HalfScreenContainerContentProps>;
  ContentRight: React.FC<HalfScreenContainerContentProps>;
} = ({ children, className, ...props }) => {
  return (
    <FullScreenContainer className={classNames("flex", className)} {...props}>
      {React.Children.map(children, (child) => {
        if (
          React.isValidElement(child) &&
          child.type === HalfScreenContainer.ContentLeft
        ) {
          return React.cloneElement(child);
        }
      })}
      {React.Children.map(children, (child) => {
        if (
          React.isValidElement(child) &&
          child.type === HalfScreenContainer.ContentRight
        ) {
          return React.cloneElement(child);
        }
      })}
    </FullScreenContainer>
  );
};

const ContentLeft: React.FC<HalfScreenContainerContentProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div {...props} className={classNames("hidden w-1/2 lg:flex", className)}>
      {children}
    </div>
  );
};

const ContentRight: React.FC<HalfScreenContainerContentProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div {...props} className={classNames("w-full lg:w-1/2", className)}>
      {children}
    </div>
  );
};

HalfScreenContainer.ContentLeft = ContentLeft;
HalfScreenContainer.ContentRight = ContentRight;

export default HalfScreenContainer;
